module.exports = __webpack_public_path__ + "kubernetes.logo.f53f2.png";


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/kubernetes/src/logo/kubernetes.logo.png
// module id = 3850
// module chunks = 0